import React from "react";
import classes from "./Preview.module.css";
import LiveSlideCard from "./LiveSlideCard";

const Preview = ({ sessionData }) => {
    if (!sessionData) return null;

    // Safely extract slides. If slide_states is empty (early WRITING phase), 
    // fall back to the blueprint so we can show the empty cards!
    let slides = sessionData.slide_states || [];
    if (slides.length === 0 && sessionData.slide_blueprint?.slides) {
        slides = sessionData.slide_blueprint.slides.map(s => ({
            ...s,
            status: "PENDING"
        }));
    }

    const sessionId = sessionData.session_id;

    return (
        <div className={classes.container}>
            <div className={classes.card}>
                <div className={classes.header}>
                    <div>
                        <h1 className={classes.title}>Slide Generation Workspace</h1>
                        <p className={classes.subtitle}>
                            {sessionData.pipeline_status === "AWAITING_HUMAN"
                                ? "Review the final deck. Say 'Looks perfect, assemble it!' in the chat."
                                : "The AI is drafting text and designing layouts in real-time..."}
                        </p>
                    </div>
                </div>

                <div className={classes.slideGrid}>
                    {slides.map((slide) => (
                        <LiveSlideCard 
                            key={slide.slide_id} 
                            sessionId={sessionId} 
                            slide={slide} 
                            pipelineStatus={sessionData.pipeline_status}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Preview;